// removed by extract-text-webpack-plugin
module.exports = {"Testimonial":"Testimonial__Testimonial___2ynPq","TestimonialColumns":"Testimonial__TestimonialColumns___1Rqzd","TestimonialColumn":"Testimonial__TestimonialColumn___1XqRv","TestimonialColumnWhite":"Testimonial__TestimonialColumnWhite___3--HC","TestimonialColumnValue":"Testimonial__TestimonialColumnValue___2fFOu"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/Testimonial/Testimonial.less
// module id = 1303
// module chunks = 0 1